<template>
    <div>
        <div v-if="String(flowConfig.full_switch) === '1' && flowConfig.full_picture && isAllowPage">
            <h5-dialog
                mode="full"
                :closeable="!(String(flowConfig.full_is_force) === '1')"
                @on-close="onCloseDialog"
                v-if="isOpen"
                style="z-index:1005;"
            >
                <img
                    class="center-img"
                    :src="flowConfig.full_picture"
                    @click="onClickCenterImg"
                />
            </h5-dialog>
        </div>
        <div v-if="String(flowConfig.foot_switch) === '1' && flowConfig.foot_picture && isBottomFlow">
            <img
                class="bottom-img"
                :src="flowConfig.foot_picture"
                @click="onClickBottomImg"
            />
        </div>
    </div>
</template>

<script>
import H5Dialog from './H5Dialog.vue'

// const centerImg = 'http://statictest.3698k.com/picture/20220704/1a60c12bdb72b91746e12135feb42522.png'
// const bottomImg = 'http://statictest.3698k.com/picture/20220704/3f7644d4b16cc9be7ca8c329acfbf0ec.png'

// 底部引流标签 自动隐藏定时器
let FlowTimeOut = null

export default {
    components: { H5Dialog },
    data() {
        return {
            // centerImg,
            // bottomImg,
            isOpen: true,
            showBottomFlow: true
        }
    },
    computed: {
        flowConfig() {
            return this.$store?.state?.app?.drainage_config || {}
        },
        isAllowPage() {
            const thePath = this.$route.path
            // 支付等页面不展示
            if (['/chargeCenter'].includes(thePath)) return false
            return true
        },
        isBottomFlow() {
            const thePath = this.$route.path
            if (this.showBottomFlow &&
              (thePath === '/login' || thePath === '/register' || thePath === '/resetPassword')
            ) {
                return true
            }
            return false
        }
    },
    methods: {
        onCloseDialog() {
            this.isOpen = false
        },
        onClickCenterImg() {
            this.toAppStore(this.flowConfig.full_apple_id)
        },
        onClickBottomImg() {
            this.toAppStore(this.flowConfig.foot_apple_id)
        },
        toAppStore(appleID) {
            if (!appleID) {
                this.isOpen = false // 关闭弹窗
                // this.$toast('跳转应用商店失败: 无appID')
                return
            }
            const AppStoreUrl = `https://apps.apple.com/us/app/id${ appleID }`

            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(AppStoreUrl)
            } else {
                // 2022.03.16 更换跳转方式
                window.location.href = AppStoreUrl
            }

            setTimeout(() => {
                // 关闭弹窗
                // this.onCloseGift()
            }, 1000)
        },
    },
    mounted() {
        // 2022.07.05 设置定时器，50秒后自动关闭 底部标签引流图片
        FlowTimeOut = setTimeout(() => {
            this.showBottomFlow = false
        }, 50 * 1000)
    },
    beforeDestroy() {
        // 移除定时器
        clearTimeout(FlowTimeOut)
    }
}
</script>

<style lang="scss" scoped>
.center-img {
    width: 100%;
}

.bottom-img {
    width: 100%;
    position: fixed;
    bottom: constant(safe-area-inset-bottom); //为底下圆弧的高度 34px
    bottom: env(safe-area-inset-bottom); //为底下圆弧的高度 34px
    left: 0;
    z-index: 1005;
}
</style>